var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"vue-store",class:_vm.mainClass},[_c('main',[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }